import { toast, TypeOptions } from "react-toastify";
import { CustomToast } from ".";

const toastMap: Record<Exclude<TypeOptions, "default">, typeof toast.success> = {
  success: toast.success,
  error: toast.error,
  info: toast.info,
  warning: toast.warn, // must use "warn" function
};

export const showCustomToast = (messages: string[], type: TypeOptions = "default") => {
  const content = <CustomToast messages={messages} />;

  if (type === "default") {
    toast(content);
  } else {
    toastMap[type](content);
  }
};